import './assets/scss/app.scss'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import AtendCrmHub from '@/plugins/signalr-hub'
import moment from 'vue-moment'
import VueCurrencyFilter from 'vue-currency-filter'
import VueResource from 'vue-resource'
import CKEditor from '@ckeditor/ckeditor5-vue'

const defaultDocumentTitle = 'AtendCrm'

router.afterEach(to => {
    // verifica se mostra ou n�o o menu lateral sempre q houver altera��o de rota
    store.commit('components/handleResize')

    if (to.meta.title) {
        document.title = `${to.meta.title} � ${defaultDocumentTitle}`
    } else {
        document.title = defaultDocumentTitle
    }
})

Vue.use(Buefy, {
    defaultDayNames: [
        'Dom',
        'Seg',
        'Ter',
        'Qua',
        'Qui',
        'Sex',
        'Sab'
    ],
    defaultMonthNames: [
        'Janeiro',
        'Fevereiro',
        'Mar�o',
        'Abril',
        'Maio',
        'Junho',
        'Julho',
        'Agosto',
        'Setembro',
        'Outubro',
        'Novembro',
        'Dezembro'
    ],
    defaultDatepickerMobileNative: false
})

Vue.use(AtendCrmHub)
Vue.use(moment)
Vue.use(VueCurrencyFilter,
    {
        symbol: 'R$',
        thousandsSeparator: '.',
        fractionCount: 2,
        fractionSeparator: ',',
        symbolPosition: 'front',
        symbolSpacing: true
    })
Vue.use(VueResource)

Vue.use(CKEditor)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
